<template>
    <div
        :class="`bg-${content.color}-50`"
        class="im--pane__content"
    >
        <div v-if="content.content.mainBody" v-html="content.content.mainBody" class="mb-4 article"></div>
        <div v-if="content.content.description" v-html="content.content.description" class="mb-8 article"></div>
        <Accordion v-for="(accordion, index) in content.content.content" :key="$uuid.v4(index)" :titleHtml="accordion.mainBody">
            <div v-if="accordion.secondaryBody" v-html="accordion.secondaryBody" class="mb-8 article"></div>
        </Accordion>
    </div>
</template>

<script>
import Accordion from '@/Scripts/components/atoms/Accordion/Accordion.vue';
export default {
    props: ['content'],
    components: {
        Accordion
    }
};
</script>
